import React, { useState } from "react";
import VideoModal from "./VideoModal";
import ImagePlayVideo from "components/utility/images/ImagePlayVideo";

const VideoPopup = ({ srcUrl, image, alt, xsImage, isMobile, xsImageAlt }) => {
	const [showModal, setShowModal] = useState(false);

	const openModal = () => {
		setShowModal((prev) => !prev);
	};

	return (
		<div className="video-popup--card">
			<button
				aria-label="open"
				tabIndex={0}
				className="video-popup--card-button"
				onClick={openModal}
			>
				<div className="video-popup--card-container">
					<img
						className="video-popup--card-image"
						src={isMobile && xsImage ? xsImage : image}
						alt={isMobile && xsImageAlt ? xsImageAlt : alt}
					/>
					<div className="video-popup--card-overlay"></div>
					<div className="video-popup--card-play-button">
						<ImagePlayVideo />
					</div>
				</div>
			</button>
			<VideoModal showClose={true} showModal={showModal} setShowModal={setShowModal} vid={srcUrl} />
		</div>
	);
};

export default VideoPopup;
